var render = function render(){var _vm=this,_c=_vm._self._c;return _c('email-form-modal',{staticClass:"text-left",attrs:{"modal-id":_vm.modalId,"title":`Email Quote ${_vm.value.number}`,"initial-emails":_vm.email ? [_vm.email] : null,"help-text":"Enter one or more emails to send the Quote to","request":_vm.submitRequest},on:{"success":(quote) => _vm.$emit('input', quote)}})
}
var staticRenderFns = []

export { render, staticRenderFns }